import { createContext, useContext, useState } from "react";
import { goToTimely } from "@/lib/booking";

const BookingContext = createContext(null);

export function BookingProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [preselect, setPreselect] = useState(null);

  // Bookings are now handled by Timely. Every "Book Now" entry point opens
  // the studio's Timely booking page instead of the in-app booking modal.
  const openBooking = () => {
    goToTimely();
  };

  return (
    <BookingContext.Provider value={{ open, setOpen, preselect, openBooking }}>
      {children}
    </BookingContext.Provider>
  );
}

export const useBooking = () => useContext(BookingContext);
